export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message',
};

export type LogoutActions = 'logout-callback' | 'logout' | 'logout-api' | 'logged-out';

export type LoginActions = 'login' | 'login-callback' | 'login-failed';

export type AuthActions = LogoutActions | LoginActions;

const prefix = '/authentication';

export const ApplicationPaths = {
  DefaultLoginRedirectPath: '/',
  AuthorizationPrefix: prefix,
  Login: `${prefix}/login`,
  LoginFailed: `${prefix}/login-failed`,
  LoginCallback: `${prefix}/login-callback`,
  LogOut: `${prefix}/logout`,
  LoggedOut: `${prefix}/logged-out`,
  LogOutCallback: `${prefix}/logout-callback`,
};
